import React, { memo } from 'react'
import { useAnnouncement, AnnouncementProps } from './useAnnouncement'
import styles from './Announcement.module.scss'
import Modal from 'components/Modal/Modal'

const Announcement: React.FC<AnnouncementProps> = (
  props: AnnouncementProps
) => {
  const { title, boxBgColor, boxTitleColor, content, setShowAnnouncementBox } =
    useAnnouncement(props)

  return (
    <div className={styles['announcement-box']}>
      <Modal
        title={title}
        bgColor={boxBgColor}
        titleColor={boxTitleColor}
        hideFooter
        onClose={() => setShowAnnouncementBox(false)}
      >
        {content}
      </Modal>
    </div>
  )
}

export default memo(Announcement)
